import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUser } from "../../../api/user";

export const fetchUser = createAsyncThunk("fetchUser", async () => {
  const res = await getUser();
  return res;
});
const initialState = {};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.res = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const { reset } = userSlice.actions;
export { userSlice };
